import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, withKeys as _withKeys, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/SKS_Logo_Negativ_RGB.png'


const _withScopeId = n => (_pushScopeId("data-v-64a03750"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu-top" }
const _hoisted_2 = { class: "menu-top-header" }
const _hoisted_3 = ["alt"]
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = ["aria-label"]

import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'NavMenu',
  props: {
    opened: { type: Boolean }
  },
  emits: ["change"],
  setup(__props: any, { emit: emits }) {





const router = useRouter();

const close = () => emits("change", false);

const handleLogoClick = () => {
    localStorage.removeItem("search_display_mode");
    close();
};

const handleRouting = (to: string, hash?: string) => {
    emits("change", false);
    
    // Clear display mode when navigating to search page
    if (to === "/") {
        localStorage.removeItem("search_display_mode");
    }
    
    if (hash) {
        setTimeout(() => {
            const element = document.getElementById(hash);
            if (element) {
                element.scrollIntoView({ behavior: "smooth" });
            }
        }, 100);
    }
    router.push(to);
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_tab_index = _resolveDirective("tab-index")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    onKeydown: _cache[5] || (_cache[5] = _withKeys(($event: any) => (close()), ["esc"])),
    "data-testid-popup": "",
    class: _normalizeClass(["menu", { opened: _ctx.opened }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives((_openBlock(), _createBlock(_component_router_link, {
          onClick: handleLogoClick,
          to: "/",
          "aria-label": _ctx.$t('aria.global.logo')
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              class: "menu-logo",
              src: _imports_0,
              alt: _ctx.$t('aria.global.logo')
            }, null, 8, _hoisted_3)
          ]),
          _: 1
        }, 8, ["aria-label"])), [
          [_directive_tab_index, _ctx.opened]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("a", {
          role: "button",
          "data-testid-times": "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (close())),
          onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (close()), ["enter"])),
          "aria-label": _ctx.$t('aria.global.close')
        }, _hoisted_6, 40, _hoisted_4)), [
          [_directive_tab_index, _ctx.opened]
        ])
      ]),
      _createElementVNode("nav", {
        "aria-label": _ctx.$t('aria.navigation.mobile'),
        class: "menu-top-content"
      }, [
        _withDirectives((_openBlock(), _createElementBlock("a", {
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (handleRouting('/')), ["prevent"]))
        }, [
          _createTextVNode(" Søg i samlingen ")
        ])), [
          [_directive_tab_index, _ctx.opened]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("a", {
          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (handleRouting('/museums')), ["prevent"])),
          to: "/museums"
        }, [
          _createTextVNode(" Museer")
        ])), [
          [_directive_tab_index, _ctx.opened]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("a", {
          onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (handleRouting('/about-page')), ["prevent"])),
          to: "/about-page"
        }, [
          _createTextVNode("Om Museernes Samlinger")
        ])), [
          [_directive_tab_index, _ctx.opened]
        ])
      ], 8, _hoisted_7)
    ])
  ], 34)), [
    [_directive_tab_index, _ctx.opened]
  ])
}
}

})